import api from "@/config/apiConfig"

class DepartmentController {

  async index ( req ) {
    try {
      const response = await api.get("/department", { params: { ...req }});
      return response.data;
    } catch ( error ) {
      console.error( "Erro no DepartmentController.index: ", error );
      throw error;
    }
  }
  async create ( req ) {
    try {
      const response = await api.post( `/department`, req );
      return response.data;
    } catch ( error ) {
      console.error( "Erro no DepartmentController.create: ", error );
      throw error;
    }
  }
  async update ( req ) {
    try {
      const response = await api.patch( `/department/${ req.id }`, req );
      return response.data;
    } catch ( error ) {
      console.error( "Erro no DepartmentController.update: ", error );
      throw error;
    }
  }
  async users ( id ) {
    try {
      const response = await api.get( `/department/${ id }/users` );
      return response.data;
    } catch ( error ) {
      console.error( "Erro no DepartmentController.users: ", error );
      throw error;
    }
  }
  async delete ( req ) {
    try {
      const response = await api.delete( `/department/${ req }` )
      return response.data
    } catch ( error ) {
      console.error( "Erro no DepartmentController.delete: ", error )
      throw error
    }
  }
}

export default new DepartmentController()
